"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InsertLinkButton = exports.InsertImageButton = exports.SizeButton = exports.IndentLessButton = exports.IndentMoreButton = exports.OrderListButton = exports.BulletListButton = exports.RemoveFormatButton = exports.HighlightButton = exports.TextColorButton = exports.StrikethroughButton = exports.UnderlineButton = exports.ItalicButton = exports.BoldButton = exports.MarkButton = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactI18next = require("react-i18next");

var _context2 = require("./context");

var _Button = _interopRequireDefault(require("./components/Button"));

var _FormatBold = _interopRequireDefault(require("@material-ui/icons/FormatBold"));

var _FormatItalic = _interopRequireDefault(require("@material-ui/icons/FormatItalic"));

var _FormatUnderlined = _interopRequireDefault(require("@material-ui/icons/FormatUnderlined"));

var _StrikethroughS = _interopRequireDefault(require("@material-ui/icons/StrikethroughS"));

var _Highlight = _interopRequireDefault(require("@material-ui/icons/Highlight"));

var _FormatClear = _interopRequireDefault(require("@material-ui/icons/FormatClear"));

var _FormatListBulleted = _interopRequireDefault(require("@material-ui/icons/FormatListBulleted"));

var _FormatListNumbered = _interopRequireDefault(require("@material-ui/icons/FormatListNumbered"));

var _FormatIndentIncrease = _interopRequireDefault(require("@material-ui/icons/FormatIndentIncrease"));

var _FormatIndentDecrease = _interopRequireDefault(require("@material-ui/icons/FormatIndentDecrease"));

var _FormatSize = _interopRequireDefault(require("@material-ui/icons/FormatSize"));

var _InsertPhoto = _interopRequireDefault(require("@material-ui/icons/InsertPhoto"));

var _InsertLink = _interopRequireDefault(require("@material-ui/icons/InsertLink"));

var _TextFormat = _interopRequireDefault(require("@material-ui/icons/TextFormat"));

var _ColorPicker = _interopRequireDefault(require("../ColorPicker"));

var _Dropdown = _interopRequireDefault(require("./components/Dropdown"));

var _DropdownList = _interopRequireDefault(require("./components/DropdownList"));

var _constants = require("../../utils/constants");

var constants = _interopRequireWildcard(require("./constants"));

var _color = _interopRequireDefault(require("color"));

var MarkButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, ref) {
  var type = _ref.type,
      children = _ref.children,
      value = _ref.value,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["type", "children", "value"]);
  var editor = (0, _context2.useEditor)();

  var _useState = (0, _react.useState)(function () {
    if (!editor) return false;
    return editor.dom.getParents(editor.selection.getNode()).some(function (node) {
      return editor.formatter.matchNode(node, type, value ? {
        value: value
      } : {});
    });
  }),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      actived = _useState2[0],
      setActived = _useState2[1];

  (0, _react.useEffect)(function () {
    if (!editor) return;

    var nodeChangeHandler = function nodeChangeHandler(e) {
      setActived(e.parents.some(function (node) {
        var isMatchNode = editor.formatter.matchNode(node, type, value ? {
          value: value
        } : {});

        if (type !== 'underline') {
          return isMatchNode;
        } // check text-decoration


        var isUnderlined = editor.dom.getStyle(node, 'text-decoration', true).includes('underline');
        return isUnderlined || isMatchNode;
      }));
    };

    editor.on('NodeChange', nodeChangeHandler);
    return function () {
      editor.off('NodeChange', nodeChangeHandler);
    };
  }, [editor, value]);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, rest, {
    ref: ref,
    active: actived,
    onClick: function onClick(e) {
      e.preventDefault();
      editor.focus();
      editor.execCommand(type, false, value);
    }
  }), children);
});
exports.MarkButton = MarkButton;
var BoldButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref2, ref) {
  var children = _ref2.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref2, ["children"]);

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t;

  return /*#__PURE__*/_react["default"].createElement(MarkButton, (0, _extends2["default"])({}, rest, {
    ref: ref,
    type: "bold",
    tooltip: t('button.formattingOptions.bold')
  }), /*#__PURE__*/_react["default"].createElement(_FormatBold["default"], {
    fontSize: "small"
  }));
});
exports.BoldButton = BoldButton;
var ItalicButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref3, ref) {
  var children = _ref3.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref3, ["children"]);

  var _useTranslation2 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation2.t;

  return /*#__PURE__*/_react["default"].createElement(MarkButton, (0, _extends2["default"])({}, rest, {
    ref: ref,
    type: "italic",
    tooltip: t('button.formattingOptions.italic')
  }), /*#__PURE__*/_react["default"].createElement(_FormatItalic["default"], {
    fontSize: "small"
  }), children);
});
exports.ItalicButton = ItalicButton;
var UnderlineButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref4, ref) {
  var children = _ref4.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref4, ["children"]);

  var _useTranslation3 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation3.t;

  return /*#__PURE__*/_react["default"].createElement(MarkButton, (0, _extends2["default"])({}, rest, {
    ref: ref,
    type: "underline",
    tooltip: t('button.formattingOptions.underline')
  }), /*#__PURE__*/_react["default"].createElement(_FormatUnderlined["default"], {
    fontSize: "small"
  }), children);
});
exports.UnderlineButton = UnderlineButton;
var StrikethroughButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref5, ref) {
  var children = _ref5.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref5, ["children"]);

  var _useTranslation4 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation4.t;

  return /*#__PURE__*/_react["default"].createElement(MarkButton, (0, _extends2["default"])({}, rest, {
    type: "strikethrough",
    ref: ref,
    tooltip: t('button.formattingOptions.strikethrough')
  }), /*#__PURE__*/_react["default"].createElement(_StrikethroughS["default"], {
    fontSize: "small"
  }), children);
});
exports.StrikethroughButton = StrikethroughButton;

var getColor = function getColor(color) {
  try {
    return (0, _color["default"])(color);
  } catch (e) {
    return null;
  }
};

var TextColorButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref6, ref) {
  var children = _ref6.children,
      appearanceMode = _ref6.appearanceMode,
      rest = (0, _objectWithoutProperties2["default"])(_ref6, ["children", "appearanceMode"]);
  var editor = (0, _context2.useEditor)();

  var _useTranslation5 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation5.t;

  var originalColor = (0, _react.useMemo)(function () {
    return (0, _color["default"])(constants['THEME_COLORS'][appearanceMode]);
  }, [appearanceMode]);

  var _useState3 = (0, _react.useState)(originalColor),
      _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
      color = _useState4[0],
      setColor = _useState4[1];

  var handleChange = function handleChange(value) {
    editor.execCommand('forecolor', false, value);
  };

  (0, _react.useEffect)(function () {
    if (!editor) return;

    var nodeChangeHandler = function nodeChangeHandler(e) {
      var node = editor.selection.getNode();

      if (!(0, _toConsumableArray2["default"])(node.style).includes('color')) {
        return setColor(originalColor);
      }

      var color = getColor(node.style.color);

      if (color) {
        setColor(color.hex() === originalColor.hex() ? originalColor : color);
      } else {
        setColor(originalColor);
      }
    };

    editor.on('NodeChange', nodeChangeHandler);
    return function () {
      editor.off('NodeChange', nodeChangeHandler);
    };
  }, [editor]);
  return /*#__PURE__*/_react["default"].createElement(_Dropdown["default"], (0, _extends2["default"])({}, rest, {
    ref: ref,
    tooltip: t('button.formattingOptions.textColor'),
    className: (0, _classnames["default"])({
      'bg-secondary text-primary': color.hex() !== originalColor.hex()
    }),
    overlay: function overlay(_ref7) {
      var onClose = _ref7.onClose;
      return /*#__PURE__*/_react["default"].createElement(_ColorPicker["default"], {
        value: color.hex(),
        onChange: function onChange(color) {
          handleChange(color);
          onClose();
        }
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_TextFormat["default"], {
    fontSize: "small"
  }), children);
});
exports.TextColorButton = TextColorButton;
var HighlightButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref8, ref) {
  var children = _ref8.children,
      appearanceMode = _ref8.appearanceMode,
      rest = (0, _objectWithoutProperties2["default"])(_ref8, ["children", "appearanceMode"]);

  var _useTranslation6 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation6.t;

  return /*#__PURE__*/_react["default"].createElement(MarkButton, (0, _extends2["default"])({}, rest, {
    ref: ref,
    type: "hilitecolor",
    value: appearanceMode === _constants.themeMode.DARK ? constants.HIGHLIGHT_DARK_COLOR : constants.HIGHLIGHT_LIGHT_COLOR,
    tooltip: t('button.formattingOptions.highlight')
  }), /*#__PURE__*/_react["default"].createElement(_Highlight["default"], {
    fontSize: "small"
  }), children);
});
exports.HighlightButton = HighlightButton;
var RemoveFormatButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref9, ref) {
  var children = _ref9.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref9, ["children"]);
  var editor = (0, _context2.useEditor)();

  var _useTranslation7 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation7.t;

  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, rest, {
    ref: ref,
    tooltip: t('button.formattingOptions.removeFormatting'),
    onClick: function onClick(e) {
      e.preventDefault();
      editor.focus();

      if (editor.selection.isCollapsed()) {
        return;
      }

      editor.execCommand('RemoveFormat');
    }
  }), /*#__PURE__*/_react["default"].createElement(_FormatClear["default"], {
    fontSize: "small"
  }), children);
});
exports.RemoveFormatButton = RemoveFormatButton;
var listTypeToNodeName = {
  bullist: 'UL',
  numlist: 'OL'
};
var listTypeToCommand = {
  bullist: 'InsertUnorderedList',
  numlist: 'InsertOrderedList'
};
var ListButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref10, ref) {
  var type = _ref10.type,
      tooltip = _ref10.tooltip,
      children = _ref10.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref10, ["type", "tooltip", "children"]);
  var editor = (0, _context2.useEditor)();
  var getActived = (0, _react.useCallback)(function (e) {
    return e.parents.some(function (node) {
      return node.nodeName === listTypeToNodeName[type];
    });
  }, []);

  var _useState5 = (0, _react.useState)(function () {
    if (!editor) return false;
    return getActived({
      parents: editor.dom.getParents(editor.selection.getNode())
    });
  }),
      _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
      actived = _useState6[0],
      setActived = _useState6[1];

  (0, _react.useEffect)(function () {
    if (!editor) return;

    var nodeChangeHandler = function nodeChangeHandler(e) {
      setActived(getActived(e));
    };

    editor.on('NodeChange', nodeChangeHandler);
    return function () {
      editor.off('NodeChange', nodeChangeHandler);
    };
  }, [editor]);
  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, rest, {
    ref: ref,
    tooltip: tooltip,
    onClick: function onClick(e) {
      e.preventDefault();
      editor.focus();
      editor.execCommand('RemoveList');
      !actived && editor.execCommand(listTypeToCommand[type]);
    },
    active: actived
  }), children);
});
var BulletListButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref11, ref) {
  var children = _ref11.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref11, ["children"]);

  var _useTranslation8 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation8.t;

  return /*#__PURE__*/_react["default"].createElement(ListButton, (0, _extends2["default"])({}, rest, {
    ref: ref,
    type: "bullist",
    tooltip: t('button.formattingOptions.bulletedList')
  }), /*#__PURE__*/_react["default"].createElement(_FormatListBulleted["default"], {
    fontSize: "small"
  }), children);
});
exports.BulletListButton = BulletListButton;
var OrderListButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref12, ref) {
  var children = _ref12.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref12, ["children"]);

  var _useTranslation9 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation9.t;

  return /*#__PURE__*/_react["default"].createElement(ListButton, (0, _extends2["default"])({}, rest, {
    ref: ref,
    type: "numlist",
    tooltip: t('button.formattingOptions.numberedList')
  }), /*#__PURE__*/_react["default"].createElement(_FormatListNumbered["default"], {
    fontSize: "small"
  }), children);
});
exports.OrderListButton = OrderListButton;
var IndentMoreButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref13, ref) {
  var children = _ref13.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref13, ["children"]);
  var editor = (0, _context2.useEditor)();

  var _useTranslation10 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation10.t;

  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({
    ref: ref
  }, rest, {
    tooltip: t('button.formattingOptions.indentMore'),
    onClick: function onClick(e) {
      e.preventDefault();
      editor.focus();
      editor.execCommand('indent');
    }
  }), /*#__PURE__*/_react["default"].createElement(_FormatIndentIncrease["default"], {
    fontSize: "small"
  }), children);
});
exports.IndentMoreButton = IndentMoreButton;
var IndentLessButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref14, ref) {
  var children = _ref14.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref14, ["children"]);
  var editor = (0, _context2.useEditor)();

  var _useTranslation11 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation11.t;

  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, rest, {
    ref: ref,
    tooltip: t('button.formattingOptions.indentLess'),
    onClick: function onClick(e) {
      e.preventDefault();
      editor.focus();
      editor.execCommand('outdent');
    }
  }), /*#__PURE__*/_react["default"].createElement(_FormatIndentDecrease["default"], {
    fontSize: "small"
  }), children);
});
exports.IndentLessButton = IndentLessButton;
var DEFAULT_FONT_SIZE = '13px';
var SIZE_OPTIONS = [{
  label: 'Small',
  value: '10px',
  size: '1'
}, {
  label: 'Normal',
  value: '13px',
  size: '2'
}, {
  label: 'Large',
  value: '18px',
  size: '4'
}, {
  label: 'Huge',
  value: '32px',
  size: '6'
}];
var SizeButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref15, ref) {
  var children = _ref15.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref15, ["children"]);
  var editor = (0, _context2.useEditor)();

  var _useTranslation12 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation12.t;

  var _useState7 = (0, _react.useState)(DEFAULT_FONT_SIZE),
      _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
      size = _useState8[0],
      setSize = _useState8[1];

  var handleChange = function handleChange(value) {
    editor.execCommand('FontSize', false, value);
  };

  (0, _react.useEffect)(function () {
    if (!editor) return;

    var nodeChangeHandler = function nodeChangeHandler(e) {
      var node = editor.selection.getNode();
      var currentFontSize = editor.dom.getStyle(node, 'font-size', true);
      setSize(currentFontSize !== null && currentFontSize !== void 0 ? currentFontSize : DEFAULT_FONT_SIZE);
    };

    editor.on('NodeChange', nodeChangeHandler);
    return function () {
      editor.off('NodeChange', nodeChangeHandler);
    };
  }, [editor]);
  return /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], (0, _extends2["default"])({}, rest, {
    ref: ref,
    tooltip: t('button.formattingOptions.size'),
    styleKey: "fontSize",
    value: size,
    options: SIZE_OPTIONS,
    onChange: handleChange,
    defaultValue: DEFAULT_FONT_SIZE
  }), /*#__PURE__*/_react["default"].createElement(_FormatSize["default"], {
    fontSize: "small"
  }), children);
});
exports.SizeButton = SizeButton;
var InsertImageButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref16, ref) {
  var onUpload = _ref16.onUpload,
      children = _ref16.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref16, ["onUpload", "children"]);
  var editor = (0, _context2.useEditor)();

  var _useTranslation13 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation13.t;

  var inputRef = (0, _react.useRef)();

  var handleUpload = /*#__PURE__*/function () {
    var _ref17 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              editor.focus();
              onUpload(e, editor);
              inputRef.current.value = '';

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function handleUpload(_x) {
      return _ref17.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, rest, {
    ref: ref,
    tooltip: t('button.insertImage'),
    onClick: function onClick(e) {
      e.preventDefault();
      inputRef.current.click();
    }
  }), /*#__PURE__*/_react["default"].createElement(_InsertPhoto["default"], {
    fontSize: "small"
  }), children), /*#__PURE__*/_react["default"].createElement("input", {
    type: "file",
    hidden: true,
    ref: inputRef,
    onChange: handleUpload,
    accept: constants.INLINE_IAMGE_MIME_TYPES.join(','),
    multiple: true
  }));
});
exports.InsertImageButton = InsertImageButton;
var InsertLinkButton = /*#__PURE__*/(0, _react.forwardRef)(function (_ref18, ref) {
  var children = _ref18.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref18, ["children"]);

  var _useTranslation14 = (0, _reactI18next.useTranslation)(),
      t = _useTranslation14.t;

  var editor = (0, _context2.useEditor)();

  var handleClick = function handleClick() {
    editor.execCommand('customInsertLink');
  };

  return /*#__PURE__*/_react["default"].createElement(_Button["default"], (0, _extends2["default"])({}, rest, {
    ref: ref,
    tooltip: t('button.insertLink'),
    onClick: function onClick(e) {
      e.preventDefault();
      handleClick();
    }
  }), /*#__PURE__*/_react["default"].createElement(_InsertLink["default"], {
    fontSize: "small"
  }), children);
});
exports.InsertLinkButton = InsertLinkButton;
//# sourceMappingURL=buttons.js.map